import React from "react";
import { Leaf } from "lucide-react";

const Logo = ({ className = "", light = false }) => {
  const textColor = light ? "text-white" : "text-gray-800";

  return (
    <div className={`flex items-center ${className}`}>
      <div className="bg-psa-green-600 p-1.5 rounded-md mr-2 flex items-center justify-center">
        <Leaf size={18} className="text-psa-gold-400" />
      </div>
      <div className={`font-display font-bold text-xl ${textColor}`}>
        <span>PSA</span>
        <span className="text-psa-gold-500 ml-1">BD</span>
      </div>
    </div>
  );
};

export default Logo;
